import WebApp from '@twa-dev/sdk'
import { useUnit } from 'effector-react'
import { useEffect, useState } from 'react'
import { $tgAccuntData, $userToken, authUserFx, setIsFirstLogin } from '@/entities/user'
import { $refreshStatus } from '@/entities/platforms/steam/store'
import { getUserProfileFx } from '@/entities/user'
import { getSteamRefreshFx } from '@/entities/platforms/steam/effects'
// import { UpdateView } from '@/features/updateView'
import { InitialScore } from '@/features/updateView/initialScore'

import { ProfileView } from '../profile/view'
import { goToProfile } from '@/app/routing/events'

export const AuthPageView = () => {
  useEffect(() => {
    console.log('AuthPageView mounted')
    goToProfile()
    setIsFirstLogin(true)
  }, [])

  const [profile, setProfile] = useState<boolean>(false) // нужен ли нам этот стейт?
  const userToken = useUnit($userToken)
  const initData = WebApp.initData
  const tgAccuntData = useUnit($tgAccuntData)

  const refreshStatus = useUnit($refreshStatus)

  useEffect(() => {
    if ((initData && userToken == null) || tgAccuntData == null) {
      // may cause loop
      authUserFx({ init_data: initData })
      console.warn('2')
    }
  }, [initData, tgAccuntData, userToken])

  useEffect(() => {
    if (userToken !== null) {
      getSteamRefreshFx(userToken)
      getUserProfileFx(userToken)
    }
  }, [userToken])

  useEffect(() => {
    if (refreshStatus === false && userToken !== null) {
      getSteamRefreshFx(userToken)
    }
  }, [userToken, refreshStatus])

  if (profile) return <ProfileView />
  return <InitialScore onClick={() => setProfile(true)} />
}
